import { Env } from 'src/app/core/config/config.model';
import { URLS } from 'src/app/core/config/url.config';
import { OcapiApiApiKey, OneMirrorAccessToken } from 'src/app/utils/global-constants';
import { DoorwayElement, type Settings } from 'src/configs/settings/settings.interface';

export const settings: Partial<Settings> = {
  doorwayConfiguration: {
    disabled: [DoorwayElement.SalesLevelType, DoorwayElement.ConfigurationDate]
  },
  apis: {
    backend: {
      baseUrl: URLS.apis.owcc.prod
    },
    carl: {
      baseUrl: URLS.apis.carl.prodCached
    },
    deeplinks: {
      baseUrl: URLS.apis.deeplinks.test
    },
    ocapi: {
      baseUrl: URLS.apis.ocapi.dev,
      apiKey: OcapiApiApiKey.Dev
    },
    omds: {
      accessToken: OneMirrorAccessToken.Int,
      baseUrl: URLS.apis.omds[Env.Int],
      relayService: URLS.apis.omdsRelayService[Env.Int]
    }
  },
  abTesting: {
    activeInStandaloneMode: true
  }
};
